import servicesUtils from "../../../utils/servicesUtils";
import { useMutation } from "react-query";

function useHideWorkspace() {
  return useMutation((id) => servicesUtils.getService(`/workspaces/${id}/hide/`));
}

export default useHideWorkspace;
